module.exports = __webpack_public_path__ + "img/ic_brand_a.05fbe7e.svg";